var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.137,
    height: 15.541,
    viewBox: "0 0 14.137 15.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-home",
    "data-name": "Icon feather-home",
    transform: "translate(-3.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14413",
    "data-name": "Path 14413",
    d: "M4.5,7.914,10.818,3l6.318,4.914v7.722a1.4,1.4,0,0,1-1.4,1.4H5.9a1.4,1.4,0,0,1-1.4-1.4Z",
    fill: "none",
    stroke: "#1984bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14414",
    "data-name": "Path 14414",
    d: "M13.5,25.02V18h4.212v7.02",
    transform: "translate(-4.788 -7.98)",
    fill: "none",
    stroke: "#1984bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbHome);
export default __webpack_public_path__ + "static/media/breadcrumb-home.0458a79e59974bbed21eb2d925da7b0f.svg";
export { ForwardRef as ReactComponent };